import { Component, Input, OnInit } from '@angular/core';

import { parsePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

@Component({
  selector: 'cc-flag-label-item',
  templateUrl: './flag-label-item.component.html',
  styleUrls: ['./flag-label-item.component.scss']
})
export class FlagLabelItemComponent implements OnInit {
  @Input() number: string;
  @Input() label: string;
  @Input() empty: string;
  @Input() numberLabel: string;

  constructor() {}

  ngOnInit() {}

  getNumbersCountry(phoneNumber: string) {
    const parsedNumber = phoneNumber && parsePhoneNumberFromString(phoneNumber.toString());
    return parsedNumber && parsedNumber.country.toLowerCase();
  }
}
